'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('story', {
        url: '/story',
        template: '<story></story>'
    });
}



// WEBPACK FOOTER //
// ./client/app/story/story.routes.js